import BaSpinner from "react-bootstrap/Spinner";

interface PropsI {
  size?: "sm";
  className?: string;
  style?: { [key: string]: string };
  spinnerStyle?: { [key: string]: string };
}

export const Loader = ({
  size,
  className,
  style = {},
  spinnerStyle = {},
}: PropsI) => {
  const defaultMargin = "2rem 0 0 0";

  return (
    <div
      style={{ opacity: 0.7, margin: defaultMargin, ...style }}
      className={`d-flex justify-content-center ${className ? className : ""}`}
    >
      <BaSpinner
        animation="border"
        role="status"
        size={size}
        style={spinnerStyle}
      >
        <span className="visually-hidden">Cargando...</span>
      </BaSpinner>
    </div>
  );
};
